import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
// import promiseMiddleware from 'redux-promise';
import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session'
import immutableTransform from 'redux-persist-transform-immutable';
import rootReducer from '../reducers';
// import ReduxDevTools from './ReduxDevTools';
import logger from './logger';
import { history } from '../../../history';

const router = routerMiddleware(history);

const persistConfig = {
  transforms: [immutableTransform()],
  key: 'root',
  // storage,
  storage: storageSession,
  whitelist: [
    'cases',
    'auth',
    'inventory',
    'contactDetails',
    'relocationTravel',
    'relocation',
    'relocationRequest',
    // aka relocationPet
    'petDetails',
  ],
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = process.env.NODE_ENV === 'production' ?
  composeEnhancers(
    applyMiddleware(createDebounce(), thunk, router),
  ) :
  composeEnhancers(
    applyMiddleware(createDebounce(), thunk, router, logger),
  );

export default function configureStore(initialState) {
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  const store = createStore(persistedReducer, initialState, enhancer);
  const persistor = persistStore(store);

  if (module.hot) {
    module.hot.accept('../reducers', () => store.replaceReducer(require('../reducers')));
  }
  return { store, persistor };
}